import { gql } from "@apollo/client";

export const GET_ORGANIZATION = gql`
  query getOrganization {
    currentOrganization {
      name
      logoUrl
      privacyPolicy
      paymentType
      gtmKey
      termsAndConditions
      translations {
        language
        termsAndConditions
        privacyPolicy
      }
    }
  }
`;
